import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@rumbledirect/ui-v2";

// Sample route behind the authentication guard. It reads the router `auth`
// context (populated from the live OIDC session) to prove the end-to-end wiring:
// guard -> reactive context -> protected page.
export const Route = createFileRoute("/_authenticated/account")({
  component: AccountPage,
});

function AccountPage() {
  const { auth } = Route.useRouteContext();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Account</CardTitle>
        <CardDescription>Details van je huidige sessie</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        <p className="flex gap-2">
          <span className="text-muted-foreground">Gebruiker</span>
          <span className="font-medium">{auth.userId ?? "onbekend"}</span>
        </p>
        <p className="flex gap-2">
          <span className="text-muted-foreground">Affiliate</span>
          <span className="font-medium">{auth.affiliateId ?? "geen"}</span>
        </p>
      </CardContent>
    </Card>
  );
}
